import * as actionTypes from '../actions/actionTypes';

export const saveFavoriteRims = ( favRims ) => ( {
    type: actionTypes.SAVE_FAVRIMS,
    favRims
} );
